import React from "react";
import __pages_import_0__ from "/src/pages/index.tsx";
const __pages_import_1__ = React.lazy(() => import("/src/pages/booking/index.tsx"));
const __pages_import_2__ = React.lazy(() => import("/src/pages/booking/payment-confirmation.tsx"));

const routes = [{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"booking","children":[{"caseSensitive":false,"path":"","element":React.createElement(__pages_import_1__)},{"caseSensitive":false,"path":"payment-confirmation","element":React.createElement(__pages_import_2__)}]}];

export default routes;